import React, { Suspense, memo } from "react";
import { NavLink, Outlet } from "react-router-dom";
import styles from "./PostLogin.module.scss";
import Navbar from "./components/Navbar/Navbar";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import Loader from "@/components/Loader/Loader";
import TitleUpdater from "@/components/TitleUpdater/TitleUpdater";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { NotificationProvider } from "@/contexts/NotificationContext";
import {
  CalendarNavIcon,
  ChatNavIcon,
  DashboardNavIcon,
  HomeNavIcon,
  ProfileNavIcon,
} from "@/components/SVGComponents/MemberIcons";
import routes from "@/routes/routes";

import { getCurrentUser } from "@/lib/utils";

const NAV_ITEMS = [
  {
    label: "Home",
    path: routes.privateRoutes.HOME.path,
    icon: HomeNavIcon,
  },
  {
    label: "Dashboard",
    path: routes.privateRoutes.DASHBOARD.path,
    icon: DashboardNavIcon,
  },
  {
    label: "Profile",
    path: routes.privateRoutes.PROFILE.path,
    icon: ProfileNavIcon,
  },
] as const;

const PostLogin: React.FC = () => {
  const user = getCurrentUser();
  const isAdmin = Boolean(user?.isAdmin || user?.role === "ADMIN");

  const mobileNavItems = isAdmin
    ? [
        {
          label: "User Management",
          path: "/admin/users-management",
          icon: DashboardNavIcon,
        },
      ]
    : NAV_ITEMS;

  return (
    <LanguageProvider>
      <NotificationProvider>
        <div className={styles.rootContainer}>
          <TitleUpdater />

          <div className={styles.desktopNavbar}>
            <Navbar />
          </div>

          <div className={styles.contentArea}>
            <Suspense fallback={<Loader />}>
              <ErrorBoundary>
                <Outlet />
              </ErrorBoundary>
            </Suspense>
          </div>

          <nav aria-label="Primary navigation" className={styles.mobileBottomNav}>
            {mobileNavItems.map(({ icon: Icon, label, path }) => (
              <NavLink
                key={label}
                className={({ isActive }) =>
                  `${styles.mobileBottomNavItem} ${
                    isActive ? styles.mobileBottomNavItemActive : ""
                  }`
                }
                to={path}
              >
                <Icon className={styles.mobileBottomNavIcon} />
                <span>{label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </NotificationProvider>
    </LanguageProvider>
  );
};

export default memo(PostLogin);
